<div class="container">
    <app-alert-line [alertLineData]="alertLine"></app-alert-line>

    <div class="jumbotron">
        <div class="row justify-content-center">
            <img src="assets/images/abdp_large.png" alt="Cabinet ABDP" />
        </div>
        <br>

        <h1>Connectez-vous</h1>
        <br>
        <form [formGroup]="loginForm" (ngSubmit)="login()">
            <div class="form-group">
                <label  for="username">Identifiant</label><br>
                <input type="email" class="form-control" placeholder="Votre e-mail" name="username" id="username" aria-label="username" formControlName="username" />
            </div>

            <div class="form-group">
                <label for="password">Mot de passe</label>
                <input type="password" class="form-control" placeholder="Saisissez votre mot de passe" name="password" aria-label="password" formControlName="password" />
            </div>

			<button type="button" class="btn btn-dark material-item" (click)="resetPassword()"><i class="material-icons md-24 icons">lock_open</i> Réinitialiser son mot de passe</button><br><br>
            <br>
            <button type="button" class="btn btn-secondary btn-lg" (click)="resetForm()">Effacer</button>
            &nbsp; &nbsp;
            <button type="submit" class="btn btn-info btn-lg" [disabled]="!loginForm.valid">Se connecter</button>
        </form>
    </div>
</div>
